import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import GoToHome from "@/auth/components/GoToHome";
import { useEnvironmentUnsafe } from "@/common/contexts/EnvironmentContext";
import { AdminUrl } from "@reflag/shared/urls";

export default function RequireBootstrapped({ children }: PropsWithChildren) {
  const { user, org } = useEnvironmentUnsafe() ?? {};

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.isReflagAdmin && org?.suspendedAt) {
      navigate("/org-suspended");
    }

    const handler = (e: KeyboardEvent) => {
      if (e.code === "KeyA" && e.altKey === true) {
        navigate(AdminUrl(org));
      }
    };

    if (user?.isReflagAdmin) {
      window.addEventListener("keydown", handler);
    }

    return () => {
      if (user?.isReflagAdmin) {
        window.removeEventListener("keydown", handler);
      }
    };
  }, [user?.isReflagAdmin, org, navigate]);

  const isMissingApp = org === undefined || org.apps.length === 0;
  const isMissingOrg = org === undefined;

  if (
    (isMissingApp || isMissingOrg) &&
    location.pathname !== "/apps/new" &&
    location.pathname !== "/get-started" &&
    !location.pathname.includes("invite")
  ) {
    return <GoToHome />;
  }

  return <>{children}</>;
}
